// api/userApi.js - Kullanıcı yönetimi API istekleri
import apiClient from './apiClient';

// Tüm kullanıcıları getir
export const getUsers = async () => {
  return await apiClient.get('/users');
};

// Belirli bir kullanıcıyı getir
export const getUserById = async (id) => {
  return await apiClient.get(`/users/${id}`);
};

// Yeni kullanıcı oluştur
export const createUser = async (userData) => {
  return await apiClient.post('/users', userData);
};

// Kullanıcı bilgilerini güncelle
export const updateUser = async (id, userData) => {
  return await apiClient.put(`/users/${id}`, userData);
};

// Kullanıcı şifresini güncelle
export const updateUserPassword = async (passwordData) => {
  return await apiClient.post('/users/update-password', passwordData);
};

// Kullanıcı sil
export const deleteUser = async (id) => {
  return await apiClient.delete(`/users/${id}`);
};

export default {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  updateUserPassword,
  deleteUser
};